module.exports = __webpack_public_path__ + "img/76038.51b22610.svg";